import { motion } from 'motion/react';
import { Container } from '@/components/ui/Container';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { fadeInUp, staggerContainer } from '@/lib/animations';

export function Terms() {
  return (
    <div className="min-h-screen bg-white dark:bg-slate-900">
      <Navbar />
      <main className="pt-24 pb-16 md:pt-32 md:pb-24">
        <Container size="narrow">
          <motion.div
            variants={staggerContainer}
            initial="hidden"
            animate="visible"
          >
            <motion.h1
              variants={fadeInUp}
              className="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-white mb-8"
            >
              Terminos de Servicio
            </motion.h1>

            <motion.div
              variants={fadeInUp}
              className="prose prose-gray dark:prose-invert max-w-none"
            >
              <p className="text-gray-600 dark:text-slate-400 mb-6">
                Ultima actualizacion: Enero 2025
              </p>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  1. Aceptacion de los Terminos
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Al acceder o utilizar Affogato, aceptas estar sujeto a estos Terminos de Servicio.
                  Si no estas de acuerdo con alguna parte de los terminos, no podras acceder al servicio.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  2. Descripcion del Servicio
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Affogato es una plataforma de almacenamiento en la nube disenada para consultores,
                  que permite organizar archivos, crear portales de cliente y gestionar proyectos
                  de consultoria. El servicio incluye funcionalidades como:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Almacenamiento seguro de archivos</li>
                  <li>Creacion de portales de cliente con URL unica</li>
                  <li>Gestion de proyectos y metodologias</li>
                  <li>Sistema de diagnosticos y formularios</li>
                  <li>Notificaciones de actividad</li>
                  <li>Asistente de inteligencia artificial (en planes seleccionados)</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  3. Cuentas de Usuario
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Para usar Affogato, debes crear una cuenta proporcionando informacion precisa y
                  completa. Eres responsable de:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Mantener la confidencialidad de tu contrasena</li>
                  <li>Todas las actividades que ocurran bajo tu cuenta</li>
                  <li>Notificarnos inmediatamente sobre cualquier uso no autorizado</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  4. Uso Aceptable
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Te comprometes a no utilizar el servicio para:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Almacenar o distribuir contenido ilegal</li>
                  <li>Violar derechos de propiedad intelectual de terceros</li>
                  <li>Transmitir malware o codigo malicioso</li>
                  <li>Intentar acceder sin autorizacion a otros sistemas</li>
                  <li>Acosar, amenazar o danar a otros usuarios</li>
                  <li>Cualquier actividad que viole leyes aplicables</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  5. Pagos y Suscripciones
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Los planes de pago se facturan de forma mensual. Al suscribirte:
                </p>
                <ul className="list-disc pl-6 text-gray-600 dark:text-slate-400 space-y-2">
                  <li>Autorizas el cargo recurrente a tu metodo de pago</li>
                  <li>Los precios pueden cambiar con aviso previo de 30 dias</li>
                  <li>Puedes cancelar en cualquier momento desde tu cuenta</li>
                  <li>No se realizan reembolsos por periodos parciales</li>
                </ul>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  6. Propiedad del Contenido
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Tu conservas todos los derechos sobre el contenido que subes a Affogato.
                  Nos otorgas una licencia limitada para almacenar, procesar y mostrar tu
                  contenido unicamente para proporcionar el servicio.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  7. Disponibilidad del Servicio
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Nos esforzamos por mantener el servicio disponible, pero no garantizamos
                  disponibilidad ininterrumpida. Podemos realizar mantenimiento programado
                  y notificaremos con antelacion cuando sea posible.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  8. Limitacion de Responsabilidad
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Affogato se proporciona "tal cual". No seremos responsables por danos
                  indirectos, incidentales o consecuentes derivados del uso del servicio.
                  Nuestra responsabilidad maxima se limita al monto pagado por el servicio
                  en los ultimos 12 meses.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  9. Terminacion
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Podemos suspender o terminar tu acceso al servicio si violas estos terminos.
                  Puedes eliminar tu cuenta en cualquier momento. Al terminar, tus datos seran
                  eliminados de acuerdo con nuestra politica de retencion.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  10. Cambios en los Terminos
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Podemos modificar estos terminos en cualquier momento. Los cambios significativos
                  seran notificados con al menos 30 dias de antelacion. El uso continuado del
                  servicio constituye aceptacion de los nuevos terminos.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  11. Ley Aplicable
                </h2>
                <p className="text-gray-600 dark:text-slate-400 mb-4">
                  Estos terminos se rigen por las leyes aplicables. Cualquier disputa sera
                  resuelta mediante arbitraje vinculante o en los tribunales competentes.
                </p>
              </section>

              <section className="mb-8">
                <h2 className="text-xl font-semibold text-gray-900 dark:text-white mb-4">
                  12. Contacto
                </h2>
                <p className="text-gray-600 dark:text-slate-400">
                  Para preguntas sobre estos terminos, contactanos en:{' '}
                  <a
                    href="mailto:hola@affogato.cloud"
                    className="text-primary-600 dark:text-primary-400 hover:underline"
                  >
                    hola@affogato.cloud
                  </a>
                </p>
              </section>
            </motion.div>
          </motion.div>
        </Container>
      </main>
      <Footer />
    </div>
  );
}
